export * from 'axios';
import axios from 'axios';
import env from '@beam-australia/react-env';

export const checkoutBffService = axios.create({
    baseURL: env('CHECKOUT_BFF_URL'),
});
